<template>
  <VideosFilterBase
    :list="tagsFilters"
    :selected="selectedTags"
    mutation="Tag"
    field="tag"
  >
    Sesiones Temáticas
  </VideosFilterBase>
</template>

<script>
import { mapState } from 'vuex'
import VideosFilterBase from '@/components/VideosFilterBase'

export default {
  components: { VideosFilterBase },

  computed: {
    ...mapState('videos', ['tagsFilters', 'selectedTags']),
  },
}
</script>
